jQuery(".menu-opener").click(function () {
  jQuery(this).toggleClass("open");
  jQuery(".mbl_navigation").toggleClass("active");
  jQuery("body").toggleClass("active");
});

jQuery(".mbl_navigation ul li.menu-item-has-children>a").click(function (e) {
  e.preventDefault();
  jQuery(this).closest("li").find(">.sub-menu").toggleClass("active");
});
if (jQuery(".radios").length) {
  window.onload = function () {
    // Check localStorage for a selected variant
    var selectedVariantId = localStorage.getItem("selectedVariantId");
    if (selectedVariantId) {
      // If a variant is stored, select that radio button
      var radioButton = document.getElementById("variant-" + selectedVariantId);
      if (radioButton) {
        radioButton.checked = true;
      }
    } else {
      // If no variant is stored, select the first one by default (already done in HTML)
      // This is just to ensure clarity, as the first one is already checked
    }

    // Add event listeners to the radio buttons
    var radioButtons = document.querySelectorAll('input[name="id"]');
    radioButtons.forEach(function (radio) {
      radio.addEventListener("change", function () {
        // Store the selected variant in localStorage
        localStorage.setItem("selectedVariantId", this.value);
      });
    });
  };
}

$(".radios label").click(function () {
  // Get the data-variant-quantity attribute of the clicked label
  var variantQuantity = $(this).data("variant-quantity");
  $("#stockMessage span").text(variantQuantity);
  console.log(variantQuantity); // Output the value to the console
});

const pollerLite = (conditions, callback, maxTime = 1000000) => {
  const POLLING_INTERVAL = 25;
  const startTime = Date.now();
  const interval = setInterval(() => {
    const allConditionsMet = conditions.every((condition) => {
      if (typeof condition === "function") {
        return condition();
      }
      return !!document.querySelector(condition);
    });
    if (allConditionsMet) {
      clearInterval(interval);
      callback();
    } else if (Date.now() - startTime >= maxTime) {
      clearInterval(interval);
    }
  }, POLLING_INTERVAL);
};

window.onload = (event) => {
  const inputElement = document.getElementById("typewriter-input");
  const staticPlaceholder = "Suche nach ";
  const textParts = ["Rollator", "Elektromobile", "Zubehör Mobilität"];

  let partIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  const typingSpeed = 100;
  const pauseDuration = 2000;

  function updatePlaceholder() {
    const currentPart = textParts[partIndex];
    const textToShow = isDeleting
      ? currentPart.substring(0, charIndex - 1)
      : currentPart.substring(0, charIndex + 1);

    // inputElement.placeholder = staticPlaceholder + textToShow;

    if (isDeleting) {
      charIndex--;
    } else {
      charIndex++;
    }

    if (charIndex === currentPart.length) {
      isDeleting = true;
      setTimeout(updatePlaceholder, pauseDuration);
    } else if (charIndex === 0 && isDeleting) {
      isDeleting = false;
      partIndex = (partIndex + 1) % textParts.length;
      setTimeout(updatePlaceholder, pauseDuration);
    } else {
      setTimeout(updatePlaceholder, typingSpeed);
    }
  }

  updatePlaceholder();

  jQuery(function () {
    jQuery(".searchenableTwo").click(function () {
      jQuery("#searchprdct2").removeClass("disabled");
      jQuery("#searchprdct1").addClass("active");
      jQuery("#searchprdct04").removeClass("disabled");
      jQuery(".opt1").text(jQuery(this).attr("dataName"));
      jQuery(".clear_home_searchBx").removeClass("d-none");
      jQuery("#maincat").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategory").val(jQuery(this).attr("dataURl"));
      jQuery("#searchcategoryh").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
      jQuery("#searchprdct2").click();
    });
  });

  jQuery(function () {
    jQuery(".searchenableThree").click(function () {
      jQuery("#searchprdct3").removeClass("disabled");
      jQuery("#searchprdct2").addClass("active");
      jQuery(".opt2").text(jQuery(this).attr("dataName"));
      jQuery("#subcat").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategory").val(jQuery(this).attr("dataURl"));
      jQuery("#searchcategoryh").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
      jQuery("#searchprdct3").click();
    });
  });

  jQuery(function () {
    jQuery(".searchenableTwo").click(function () {
      jQuery("#searchprdct6").removeClass("disabled");
      jQuery("#searchprdct08").removeClass("disabled");
      jQuery("#searchprdct5").addClass("active");
      jQuery(".opt1").text(jQuery(this).attr("dataName"));
      jQuery("#maincatmbl").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategorymbl").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
    });
  });

  jQuery(function () {
    jQuery(".searchenableThree").click(function () {
      jQuery("#searchprdct7").removeClass("disabled");
      jQuery("#searchprdct6").addClass("active");
      jQuery(".opt2").text(jQuery(this).attr("dataName"));
      jQuery("#subcatmbl").val(jQuery(this).attr("dataID"));
      jQuery("#searchcategorymbl").val(jQuery(this).attr("dataID"));
      loadContent(
        "/pages/filter/?section_id=filters&data=" + jQuery(this).attr("dataID")
      );
    });
  });

  jQuery(".clearsrchsval").click(function (e) {
    e.preventDefault();
    //document.getElementsByClassName("opt1").innerHTML = "Happy Birthday!"
    jQuery(".opt1").text("Gesuchtes Produkt");
    jQuery(".opt2").text("Verfeinern Sie Ihre Suche");
    jQuery(".opt3").text("Weitere Optionen");
    jQuery("#searchprdct2").addClass("disabled");
    jQuery("#searchprdct3").addClass("disabled");
    jQuery("#searchprdct04").addClass("disabled");
    jQuery("#searchprdct1").removeClass("active");
    jQuery("#searchprdct2").removeClass("active");
    jQuery("#searchprdct6").addClass("disabled");
    jQuery("#searchprdct7").addClass("disabled");
    jQuery("#searchprdct08").addClass("disabled");
    jQuery("#searchprdct5").removeClass("active");
    jQuery("#searchprdct6").removeClass("active");
    jQuery(".hidden-val").val("");
    jQuery(".hidden-val").focus();
    jQuery("#searchprdct6").removeClass("active");
    jQuery(".clear_home_searchBx").addClass("d-none");
  });

  var close_container = $(".search_toggleDiv");
  $(".close_search_h").on("click", function (e) {
    close_container.fadeOut();
  });

  function loadContent(pageHandle) {
    // var urldata='https://networcare.myshopify.com'+$("#searchcategory").val();
    // if($("#searchqueary").val()!=''){
    //     urldata=urldata+$("#searchqueary").val();
    // }else{
    //   urldata=urldata+'?view=ajax';
    // }
    fetch(
      "https://www.samedo.de" +
        $("#searchcategory").val() +
        "?view=ajax",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .then((response) => response.text())
      .then((html) => {
        // console.log(html);
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        console.log('doc ',doc);
        const newProductGrid = doc.getElementById("facetDataHome").innerHTML;
        console.log('newProductGrid : ',newProductGrid);
        console.log(doc.getElementById("facetDataHome").length);
        if (
          newProductGrid.includes("Keine Variationen Verfügbar") ||
          newProductGrid.includes("keine variationen verfügbar")
        ) {
          $("#searchprdct3").addClass("disabled");
          $("#searchprdct3").addClass("remove");
        }
        // if(doc.getElementById('facetDataHome').length>1){
        //   jQuery("#main-collection-filters").html(newProductGrid);
        // }else{
        //    $("#searchprdct3").addClass("disable");
        //    $("#searchprdct3").addClass("remove");
        // }

        jQuery("#main-collection-filters").html(newProductGrid);
      })
      .catch((error) => console.error("Error here:", error));
  }

  jQuery(".searchprdctpop-target").fadeOut();
  jQuery(function () {
    jQuery(".search-single").click(function () {
      if (!jQuery(this).hasClass("disabled")) {
        /*parseInt(jQuery(this).attr("search-target"))+1;
                  jQuery('#searchprdct2').removeClass('disabled');*/
        jQuery(".searchprdctpop-target").fadeOut();
        jQuery("#searchprdctpop" + $(this).attr("search-target")).fadeIn();
        if (parseInt(jQuery(this).attr("search-target")) == 1) {
          jQuery("#searchprdct2").addClass("disabled");
          jQuery("#searchprdct2").removeClass("active");
          jQuery("#searchprdct3").addClass("disabled");
          jQuery("#searchprdct3").removeClass("active");
          jQuery("#searchprdct04").addClass("disabled");
          jQuery(".opt2").text("Verfeinern Sie Ihre Suche");
          jQuery(".opt3").text("Weitere Optionen ");
          jQuery("#searchqueary").val("");
          jQuery("#searchcategoryh").val("");
        }

        if (parseInt(jQuery(this).attr("search-target")) == 2) {
          jQuery("#searchprdct3").addClass("disabled");
          jQuery("#searchprdct3").removeClass("active");
          jQuery("#searchprdct04").removeClass("disabled");
          jQuery(".opt3").text("Weitere Optionen ");
          jQuery("#searchqueary").val("");
        }

        maincatID = jQuery("#maincat").val();
        console.log("main cat", maincatID);
        jQuery(".searchenableThree").hide();
        jQuery(".prnt-" + maincatID).css("display", "block");
      }
      //jQuery('.cart-single').removeClass('active');
      //jQuery('#cartmenu'+$(this).attr('search-target')).addClass('active');
    });
  });

  $(".buttonforsearch").click(function (e) {
    if (!$(this).hasClass("disabled")) {
      // if($("#searchqueary").val()==''){
      //    window.location.href=$("#searchcategory").val()+$("#searchqueary").val()
      // }else{
      //    window.location.href=$("#searchcategory").val()+$("#searchqueary").val()
      // }
      window.location.href =
        $("#searchcategory").val() + $("#searchqueary").val();
    }
  });
  $(document).mouseup(function (e) {
    var container = $(".search_toggleDiv");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.hide();
    }
  });

  var containers = $(".search_toggleDiv");
  $(".searchPrdctListBx").on("click", function (e) {
      e.preventDefault();
    containers.fadeOut();
  });

  // setTimeout(function () {
  //   jQuery(function () {
  //     jQuery("select.select6").each(function () {
  //       jQuery(this).select2({
  //         //theme: 'bootstrap4',
  //         //minimumResultsForSearch: -1,
  //         width: "100%",
  //         closeOnSelect: true,
  //         allowClear: false,
  //         placeholder: jQuery(this).attr("placeholder"),
  //         //allowClear: Boolean(jQuery(this).data('allow-clear')),
  //         dropdownParent: $("#locations"),
  //       });
  //     });
  //   });
  // }, 500);

  // const swiper6 = new Swiper(".recomendation_slides", {
  //   slidesPerView: 1,
  //   spaceBetween: 16,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //              el: '.swiper-pagination',
  //            },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper = new Swiper(".hme_partnersSldr", {
  //   slidesPerView: 7,
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /* pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     576: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //     992: {
  //       slidesPerView: 7,
  //       spaceBetween: 10,
  //     },
  //   },
  //   // And if we need scrollbar
  //   /* scrollbar: {
  //               el: '.swiper-scrollbar',
  //             },*/
  // });

  // const swiper2 = new Swiper(".hme_popularPrdctsSldr", {
  //   slidesPerView: "auto",
  //   spaceBetween: 16,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper3 = new Swiper(".leading_storeSlides", {
  //   slidesPerView: "auto",
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /* pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   /*breakpoints: {
  //                   320: {
  //                     slidesPerView: 1,
  //                     spaceBetween: 10,
  //                   },
  //                   576: {
  //                     slidesPerView: 2,
  //                     spaceBetween: 10,
  //                   },
  //                   768: {
  //                     slidesPerView: 2,
  //                     spaceBetween: 10,
  //                   },
  //                   992: {
  //                     slidesPerView: 7,
  //                     spaceBetween: 10,
  //                   },
  //               },*/
  //   // And if we need scrollbar
  //   /* scrollbar: {
  //               el: '.swiper-scrollbar',
  //             },*/
  // });

  // const swiper4 = new Swiper(".wheelchair_prdctSlder", {
  //   slidesPerView: 1,
  //   spaceBetween: 10,
  //   freeMode: true,
  //   loop: true,
  //   centeredSlides: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper5 = new Swiper(".wheelchair_prdctSldesPrdct", {
  //   slidesPerView: 1,
  //   centeredSlides: true,
  //   spaceBetween: 10,
  //   freeMode: true,
  //   loop: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper8 = new Swiper(".jahren_onlineSlidr", {
  //   //slidesPerView: 1,
  //   spaceBetween: 10,
  //   freeMode: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: 1,
  //       spaceBetween: 10,
  //     },
  //     768: {
  //       slidesPerView: 2,
  //       spaceBetween: 10,
  //     },
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  // const swiper9 = new Swiper(".unser_antriebBoxesSldes", {
  //   slidesPerView: "auto",
  //   spaceBetween: 20,
  //   freeMode: true,

  //   // If we need pagination
  //   /*pagination: {
  //               el: '.swiper-pagination',
  //             },*/

  //   // Navigation arrows
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     320: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     992: {
  //       slidesPerView: "auto",
  //       spaceBetween: 10,
  //     },
  //     1200: {
  //       slidesPerView: "auto",
  //       spaceBetween: 20,
  //     },
  //   },

  //   // And if we need scrollbar
  //   //scrollbar: {
  //   //el: '.swiper-scrollbar',
  //   //},
  // });

  pollerLite(
    [".suitable_acess_Sldr", () => $(".suitable_acess_Sldr").length > 0],
    () => {
      new Swiper(".suitable_acess_Sldr", {
        slidesPerView: "auto",
        spaceBetween: 16,
        loop: true,
        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    }
  );

  $(document).on("click", ".simpAskQuestionForm-btnOpen", function () {
    $(".simpAskSubmitForm > .button").val("Abschicken");
    $(".simpAskForm-cancel-btn").text("Abberchen");
    $("input.simpAsk-fifty-percent[name=name]").attr("placeholder", "Ihr Name");
    $("input.simpAsk-fifty-percent[name=email]").attr(
      "placeholder",
      "Ihr Email"
    );
    $("textarea[name=question]").attr("placeholder", "Stellen Sie eine Frage");
  });

  $(".add").click(function () {
    $(this)
      .prev()
      .val(+$(this).prev().val() + 1);
  });
  $(".sub").click(function () {
    if ($(this).next().val() > 0)
      $(this)
        .next()
        .val(+$(this).next().val() - 1);
  });

  $(".nav-tabs-selector").on("change", function (e) {
    var atthis = "#nav-"+$(this).val();
    $(this).closest(".popular_prdcts_sect").find(".tab-pane").removeClass("show active");
    $(atthis).addClass("show active");
    $(this).closest(".popular_prdcts_sect").find(".nav-tabs ul li a").eq($(this).val()).tab("show");
  });

  if ($(window).width() < 1200) {
    $(".footer_links h6").click(function () {
      $(this).next(".footer_links ul").slideToggle();
      $(this).toggleClass("tglesldr");
    });
    $(".popular_prdctsColorAvail--drop h3").click(function () {
      $(this).next(".popular_prdctsColorAvailLstng").slideToggle();
      $(this).toggleClass("tglesldr");
    });
  }

  $(".color-swatch").hover(function () {
    prodid = $(this).attr("prodid");
    matchingdata = $(this).attr("val");
    finded = false;
    if ($(".img-" + prodid).length > 0) {
      $(".img-" + prodid).each(function () {
        datatitle = $(this).attr("datatitle").toLowerCase();
        if (finded == false) {
          if (datatitle.includes(matchingdata.toLowerCase())) {
            $(".img-" + prodid).css("display", "none");
            $(this).css("display", "block");
            $("#mainimage" + prodid).css("display", "none");

            finded = true;
          }
        }
      });
    } else {
      $("#mainimage" + prodid).css("display", "block");
    }
  });

  $(document).on("click", ".epr-collaps-btn", function () {
    $("#description").siblings(".form-label").text("Bewertung Beschreibung");
    $("#description").prop("required", false);
    $("#title").prop("required", true);
    $("#title")
      .siblings(".form-label")
      .html("Titel der Bewertung<span style='color:red'>*</span>");
  });

  $(document).on("change", "#location_serach", function () {
    if ($(this).val() != "") {
      $(".locationsubmit").prop("disabled", false);
    } else {
      $(".locationsubmit").prop("disabled", true);
    }
  });

  $("#status_checkBxOne").on("click", function () {
    $("#status_checkBxTwo").addClass("status_checkBx--offline");
    $("#status_checkBxOne").removeClass("status_checkBx--offline");
    $(".market_location_description").show();
    $(".selected_location_lable").html("");
    $("#pickupstore").val("");

    // Access the Select2 container
    var $select2Container = $("#location_serach").data("select2").$dropdown;
    // Find and clear the search input field
    var $searchInput = $select2Container.find("input.select2-search__field");
    $searchInput.val("").trigger("input");
    // Optionally, clear selection
    $("#location_serach").val(null).trigger("change");
  });

  $(document).on("click", ".locationsubmit", async function () {
    if ($("#location_serach").length > 0 && $("#location_serach").val() != "") {
      $("#pickupstore").show();
      $("#pickupstore").val($("#location_serach").val());
      $(".status_checkBx").removeClass("status_checkBx--offline");
      $(".status_checkBx").first().addClass("status_checkBx--offline");
      $(".market_location_description").hide();
      $(".selected_location_lable").html($("#location_serach").val());
      $("#locations").modal("hide");
    }
  });
};

// Auto select the size 
function selectVariantOnPriceMatch() {
  const priceElement = document.querySelector(".product-info__sticky span._ks_text b");

  if (priceElement) {
    const priceValue = priceElement.innerHTML.trim();

    document.querySelectorAll("sticky-scroll-direction fieldset input").forEach(input => {
      if (input.value.trim() === priceValue) {
        const label = input.nextElementSibling;

        if (label && label.tagName.toLowerCase() === "label") {
          const labelTitle = label.getAttribute("title");
          const blockedTitles = ["Unavailable", "Sold out", "Nicht verfügbar", "Ausverkauft"];

          if (blockedTitles.includes(labelTitle)) {
            const fieldset = input.closest("fieldset");
            const fallbackInput = fieldset?.querySelector('input:not(.is-unavailable)');
            const fallbackLabel = fallbackInput && fieldset?.querySelector(
              `label[for="${fallbackInput.id}"]:not([title="Unavailable"]):not([title="Sold out"]):not([title="Nicht verfügbar"]):not([title="Ausverkauft"])`
            );

            if (fallbackInput && fallbackLabel) {
              fallbackLabel.click();
            }
          } else {
            label.click();
          }
        }
      }
    });
  } else {
    // Fallback when price element is not found
    const fieldsets = document.querySelectorAll("sticky-scroll-direction fieldset");
    let allPreselectedValid = true;

    fieldsets.forEach(fieldset => {
      if (fieldset.getAttribute("option_name") === "Farbe") return;

      const selectedInput = fieldset.querySelector("input:checked");
      const selectedLabel = selectedInput && fieldset.querySelector(`label[for="${selectedInput.id}"]`);
      const labelTitle = selectedLabel?.getAttribute("title");

      const isBlocked = ["Unavailable", "Sold out", "Nicht verfügbar", "Ausverkauft"].includes(labelTitle);

      if (!selectedInput || !selectedLabel || isBlocked) {
        allPreselectedValid = false;
      }
    });

    // Only run fallback if at least one fieldset is not valid
    if (!allPreselectedValid) {
      console.warn("Price element not found, selecting first available variant");

      fieldsets.forEach(fieldset => {
        if (fieldset.getAttribute("option_name") === "Farbe") return;

        const fallbackInput = fieldset.querySelector('input:not(.is-unavailable)');
        const fallbackLabel = fallbackInput && fieldset.querySelector(
          `label[for="${fallbackInput.id}"]:not([title="Unavailable"]):not([title="Sold out"]):not([title="Nicht verfügbar"]):not([title="Ausverkauft"])`
        );

        if (fallbackInput && fallbackLabel) {
          fallbackLabel.click();
        }
      });
    }
  }
}

// Attach event listeners to "Farbe" inputs
document.querySelectorAll('fieldset[option_name="Farbe"] input').forEach(input => {
  input.addEventListener("click", () => {
    setTimeout(selectVariantOnPriceMatch, 250);
  });
});

// Initial call after a short delay
setTimeout(selectVariantOnPriceMatch, 2500);

// Observe dynamic DOM changes to re-attach listeners or re-select variants
const observer = new MutationObserver(() => {
  const inputFields = document.querySelectorAll(".kiwi-sizing-modal input.element-input[type='number']");

  if (inputFields.length < 1) {
    // selectVariantOnPriceMatch();
  } else {
    inputFields.forEach(input => {
      input.addEventListener("change", selectVariantOnPriceMatch);
    });
  }
});

// Start observing the document for changes
observer.observe(document.body, { childList: true, subtree: true });

// Close moga menu when mouse leave 
const mainNav = document.querySelector('.main-nav');
const megaNav = document.querySelector('.js-mega-nav');

[mainNav, megaNav].forEach(el => {
  el.addEventListener('mouseleave', () => {
    megaNav.classList.remove('is-open');
    megaNav.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  });
});